function generateValidId(str) {
	// Replace spaces with underscores
	let validId = str.replace(/\s+/g, '_');

	// Remove non-alphanumeric characters except underscores, dashes, and periods
	validId = validId.replace(/[^\w-.]/g, '');

	// Remove leading digits if the ID starts with a digit
	validId = validId.replace(/^\d+/, '');

	// Remove periods
	validId = validId.replace(/\./g, '');

	// Make sure the ID doesn't start with a dash or period
	if (/^[-.]/.test(validId)) {
	validId = '_' + validId;
	}

	// remove &
	validId = validId.replace(/&/g, '');

	return validId;
}

export default generateValidId;